import { Col, DatePicker, Input, Row } from "antd";
import React from "react";
import SelectBranch from "../../components/SelectBranch";
import { useDispatch, useSelector } from "react-redux";
import {
  actionStoreQrTracking,
  filterSelector,
} from "../../../../../redux/slices/store-qr/tracking";

const TrackingFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector(filterSelector);
  const { SET_FILTER } = actionStoreQrTracking;

  const handleChangeFilter = (payload) => {
    dispatch(
      SET_FILTER({
        ...payload,
        page: 1,
      })
    );
  };

  return (
    <Row gutter={[16, 16]}>
      <Col md={12}>
        <Input.Search
          placeholder="เลขที่ใบเสร็จ, เลขที่ใบจอง, เลขที่คำสั่งซื้อ, รหัสสมาชิก, ชื่อสมาชิก"
          defaultValue={filter.search}
          onSearch={(value) => {
            handleChangeFilter({ search: value });
          }}
        />
      </Col>
      <Col md={6}>
        <DatePicker.RangePicker
          placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
          format={"DD/MM/YYYY"}
          value={[filter.start_date, filter.end_date]}
          onChange={(values) => {
            handleChangeFilter({ start_date: values[0], end_date: values[1] });
          }}
          title="วันที่ใบเสร็จ"
        />
      </Col>
      <Col md={6}>
        <SelectBranch
          withAll
          className="w-100"
          value={filter.receive_branch_code}
          onChange={(value) => {
            handleChangeFilter({ receive_branch_code: value });
          }}
          title="สาขาที่รับสินค้า"
        />
      </Col>
    </Row>
  );
};

export default TrackingFilter;
